export default function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}